/**
 * Deterministic pseudo-random helpers, seeded from a string key (a book
 * id), so the same book always renders the same mock community data across
 * reloads without persisting anything — this is the seam every function in
 * communityBookData.js is built on.
 */

function hashStringToSeed(str) {
  let hash = 0;
  const s = String(str);
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  return hash;
}

function mulberry32(seed) {
  let a = seed;
  return function rng() {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** A repeatable RNG function for a given key — same key, same sequence. */
export function seededRandom(key) {
  return mulberry32(hashStringToSeed(key));
}

export function randInt(rng, min, max) {
  return min + Math.floor(rng() * (max - min + 1));
}

/** Picks up to `n` distinct items from `arr` without replacement. */
export function pickN(rng, arr, n) {
  const pool = [...arr];
  const chosen = [];
  while (chosen.length < n && pool.length > 0) {
    const idx = Math.floor(rng() * pool.length);
    chosen.push(pool.splice(idx, 1)[0]);
  }
  return chosen;
}

export function pickOne(rng, arr) {
  return arr[Math.floor(rng() * arr.length)];
}
